// src/pages/UrunlerSayfasi.js
import React, { useEffect, useState } from 'react';
import Urunler from './Urunler';

const UrunlerSayfasi = () => {
  const [veriHazir, setVeriHazir] = useState(false);

  useEffect(() => {
    // Eğer localStorage'da veri yoksa ve sayfa yenilendiyse otomatik çek
    const localVeri = localStorage.getItem('urunler');
    if (!localVeri) {
      fetch('/urunler.json')
        .then(res => res.json())
        .then(data => {
          localStorage.setItem('urunler', JSON.stringify(data));
          setVeriHazir(true);
        });
    } else {
      setVeriHazir(true);
    }
  }, []);

  return (
    <div className="urunler-sayfa-wrapper">
      <h1 style={{ textAlign: 'center' }}>Ürünlerimiz</h1>
      {veriHazir ? <Urunler /> : <p style={{ textAlign: 'center' }}>Yükleniyor...</p>}
    </div>
  );
};

export default UrunlerSayfasi;
